<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'
import { richTextImgHandler } from '@/utils/common'

export default {
  name: 'Comp58',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      admini: localStorage.getItem('admini')
    }
  },
  methods: {
    getShadowColor, getPageThemeColor, richTextImgHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-58">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-58-content pointer">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-58-${i}`"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        class="item"
        :class="{'martop': i % 2 !== 0}"
        @click="onModuleItem(v)"
      >
        <div class="item-content">
          <p class="item-title">{{ v.headline || '' }}</p>
          <p class="rich-text rich-text2" v-html="richTextImgHandler(v.memo)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.modules-id-58 {
  .rich-text2 {
    font-size: 10px !important;
    p, span, i {
      font-size: 10px !important;
      line-height: 20px !important;
      background-color: #fff !important;
      font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
      padding: 0 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.modules-id-58-content {
  height: 100%;
  display: flex;
  column-gap: 20px;
  align-items: flex-start;
}
.item {
  width: 164px;
  height: 246px;
  border-radius: 5px;
  background: url('~imgs/modules/module-58-bg.webp') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
}
.martop {
  margin-top: 44px;
}
.item-content {
  width: 133px;
  height: 216px;
  box-sizing: border-box;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .item-title {
    min-width: 88px;
    // min-height: 30px;
    background-color: #5F977D;
    border-radius: 2px;
    font-size: 10px;
    transform: scale(.8);
    font-family: siyuansong;
    font-weight: 800;
    color: #fff;
    line-height: 25px;
    padding: 1px 6px;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    margin-top: 4px;
  }
  .rich-text2 {
    width: 133px;
    display: block;
    margin-top: 8px;
  }
}
</style>
